import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Box } from "@mui/material";
import italia from "../images/italia.jpg";
import francia from "../images/francia.jpg";
import alemania from "../images/alemania.jpg";
import brasil from "../images/brasil.jpg";
import inglaterra from "../images/inglaterra.jpg";
import usa from "../images/usa.jpg";
import portugal from "../images/portugal.jpg";

function Carrousel() {
  var settings = {
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    speed: 3000,
    cssEase: "linear",
  };
  return (
    <Box
      sx={{ display: "block", width: { xs: "90vw", sm: "90vw", md: "70vw" } }}
    >
      <div className="slider-container">
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            padding: "15px 0 15px 0",
            fontWeight: "bold",
            fontSize: "24px",
            color: "#077f83",
          }}
        >
          Tenemos traducciones en diferentes idiomas
        </Box>
        <Slider {...settings}>
          <Box>
            <img src={usa} alt="traduccion frances" className="banderas" />
          </Box>
          <Box>
            <img
              src={inglaterra}
              alt="traduccion ingles"
              className="banderas"
            />
          </Box>
          <Box>
            <img src={brasil} alt="traduccion portugues" className="banderas" />
          </Box>
          <Box>
            <img src={alemania} alt="traduccion aleman" className="banderas" />
          </Box>
          <Box>
            <img src={italia} alt="traduccion italiano" className="banderas" />
          </Box>
          <Box>
            <img src={francia} alt="traduccion frances" className="banderas" />
          </Box>
          <Box>
            <img
              src={portugal}
              alt="traduccion portugues"
              className="banderas"
            />
          </Box>
        </Slider>
      </div>
    </Box>
  );
}

export default Carrousel;
